//! get angle for wagonWheel cords
export function degreeToRadians(d) {
  return (d * Math.PI) / 180
}

//! new cords
export function renderNewCords(x, y) {
  // const element = document?.getElementById('wagonWheel')
  const paperWidth = 400
  const paperHalf = parseInt(paperWidth, 10) / 2
  const nx = paperHalf + x * Math.cos(degreeToRadians(-y))
  const ny = paperHalf + x * Math.sin(degreeToRadians(-y))
  if (x !== 0 && y !== 0) {
    const d = { x: parseInt(nx), y: parseInt(ny) }
    return d
  }
  return null
}

//! X axis as per run
export function getXaxis(x, run) {
  if (x >= 350) {
    if (parseInt(run) === 6) {
      x = 192
    } else if (parseInt(run) >= 4) {
      x = 184
    } else {
      x = 180
    }
  } else if (x > 250 && x < 350) {
    x -= 150
  } else if (x > 140 && x <= 250) {
    x -= 100
  } else if (x > 55 && x <= 140) {
    x -= 50
  }

  if (parseInt(run) < 4 && x > 175) {
    x = 150
  }
  return x
}

// !runs
export const getRun = {
  '1s': 1,
  '2s': 2,
  '3s': 3,
  '4s': 4,
  '6s': 6
}
